import * as React from 'react';
import styled from 'styled-components';
import { Icon, media, themeGet } from '@packages/ui';
import { Clickout } from '@packages/shared';
import { ClickoutArea, Product } from '@packages/common';
import { TopRightElementBase } from './TopRightElementBase';

const MAGNIFYING_GLASS_ICON_SIZE = 16;

const MagnifyingGlassContainer = styled(TopRightElementBase)`
  top: 40px;
  > span {
    margin-right: ${themeGet.space(1)};
    margin-left: ${themeGet.space(1)};
  }
  ${media.to.md`
    display: none;
  `}
`;

export const MagnifyingGlassButton: React.FC<{ sorted: boolean; product: Product; index: number }> = ({
  sorted,
  product,
  index,
}) => {
  return (
    <Clickout sorted={sorted} product={product} area={ClickoutArea.MAGNIFYING_GLASS} index={index}>
      <MagnifyingGlassContainer>
        <Icon name="search" size={MAGNIFYING_GLASS_ICON_SIZE} color="sandDune"></Icon>
      </MagnifyingGlassContainer>
    </Clickout>
  );
};
